import { render, staticRenderFns } from "./Timetable.vue?vue&type=template&id=00b35c7a&"
var script = {}
import style0 from "./Timetable.vue?vue&type=style&index=0&id=00b35c7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports